import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackRemovedClipsFromBoard } from "@air/analytics";
import { Boards } from "@air/api";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { useToasts } from "@air/provider-toast";
import { resetSelectedItemsAction } from "@air/redux-selected-items";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import pluralize from "pluralize";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useShowSubscriptionExpiredModal } from "~/hooks/useShowSubscriptionExpiredModal";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { useUpdateBoardStats } from "~/utils/mutateUtils/BoardStats";
import { useRemoveAssetsFromAllViews } from "~/utils/mutateUtils/GalleryAssets";
export const RemoveAssetsFromBoardModal = (param)=>{
    let { clipIds, onComplete = noop, onClose, trackLocation, boardId, boardTitle } = param;
    const dispatch = useDispatch();
    const { showToast } = useToasts();
    const [removing, setRemoving] = useState(false);
    const { removeAssetsFromAllViews } = useRemoveAssetsFromAllViews();
    const { updateBoardStats } = useUpdateBoardStats();
    const { trackRemovedClipsFromBoard } = useTrackRemovedClipsFromBoard();
    const { showingSubscriptionExpiredModal } = useShowSubscriptionExpiredModal({
        onClose
    });
    const { currentWorkspace } = useCurrentWorkspace();
    const workspaceId = currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id;
    if (showingSubscriptionExpiredModal) {
        return null;
    }
    const onRemoveClips = async ()=>{
        setRemoving(true);
        if (!workspaceId) {
            throw new Error("No workspaceId found");
        }
        try {
            await Boards.removeClips({
                boardId,
                clipIds,
                workspaceId
            });
            trackRemovedClipsFromBoard({
                boardId,
                clipIds,
                location: trackLocation
            });
            removeAssetsFromAllViews({
                clipIds,
                parentBoardId: boardId
            });
            updateBoardStats(boardId);
            onComplete();
            dispatch(resetSelectedItemsAction());
            showToast("".concat(pluralize("item", clipIds.length, true), " removed from ").concat(boardTitle));
            onClose();
        } catch (error) {
            reportErrorToBugsnag({
                error,
                context: "Failed to remove assets a board",
                metadata: {
                    data: {
                        clipIds,
                        boardId
                    }
                }
            });
        }
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "remove-clips-from-board-modal",
        isOpen: true,
        title: "Remove from ".concat(boardTitle || "board"),
        description: "The ".concat(pluralize("assets", clipIds.length, false), " will still be accessible in search results."),
        onDismiss: onClose,
        ctaPrimaryText: removing ? "Removing..." : "Remove",
        isLoading: removing,
        isDisabled: removing,
        onConfirm: onRemoveClips
    });
};
